import { create } from 'zustand';
import { IbackofficeUserData } from '../types/configuration.types';

interface IUsersState {
  users: IbackofficeUserData[];
  setUsers: (users: IbackofficeUserData[]) => void;
}

const useUsersState = create<IUsersState>(set => ({
  users: [],
  setUsers: users => set({ users })
}));

export default useUsersState;
